export const REPUTATION_COLORS = {
    legend: 'warning',
    master: 'secondary',
    collector: 'primary',
    casual: 'info',
};

export function reputationProgress(reputation) {
    if (!reputation) return 0;
    const { points, levelThreshold, nextLevelThreshold } = reputation;
    if (!nextLevelThreshold) return 100;
    return Math.min(100, Math.max(0, ((points - levelThreshold) / (nextLevelThreshold - levelThreshold)) * 100));
}
